/**
 * Maps subsections (or hiddenSubsections) to the form schema format for save/API.
 * Normalizes subsection and element shape including gridElements and smartChipId.
 * @param {Array} subsections - Array of subsection objects (subsections or hiddenSubsections)
 * @returns {Array} Mapped subsections for form schema
 * @author Abhishek Dhillon
 */
export const mapSubsectionsToSchemaFormat = (subsections) => {
  if (!subsections?.length) return [];
  return subsections.map((sub) => ({
    id: sub.id,
    title: sub.title || "",
    color: sub.color,
    showIf: sub.showIf,
    showIfExpression: sub.showIfExpression,
    elements: (sub.elements || []).map((element) => {
      const mappedElement = {
        id: element.id,
        type: element.type,
        name: element.name,
        ...(element.smartChipId && { smartChipId: element.smartChipId }),
        properties: element.properties,
        showIf: element.showIf,
        showIfExpression: element.showIfExpression,
      };
      if (element.gridElements) {
        mappedElement.gridElements = element.gridElements.map((row) =>
          row.map((gridElement) => {
            if (!gridElement) return null;
            return {
              id: gridElement.id,
              type: gridElement.type,
              name: gridElement.name,
              ...(gridElement.smartChipId && { smartChipId: gridElement.smartChipId }),
              properties: gridElement.properties,
              showIf: gridElement.showIf,
              showIfExpression: gridElement.showIfExpression,
            };
          })
        );
      }
      return mappedElement;
    }),
  }));
};
